import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
import cities5ebe3c from './cities'
/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:16
* @route '/admin/catalog/locations/states'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/catalog/locations/states',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:16
* @route '/admin/catalog/locations/states'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:16
* @route '/admin/catalog/locations/states'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:16
* @route '/admin/catalog/locations/states'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:16
* @route '/admin/catalog/locations/states'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:16
* @route '/admin/catalog/locations/states'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:16
* @route '/admin/catalog/locations/states'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::create
* @see app/Http/Controllers/Admin/Locations/StateController.php:32
* @route '/admin/catalog/locations/states/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/catalog/locations/states/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::create
* @see app/Http/Controllers/Admin/Locations/StateController.php:32
* @route '/admin/catalog/locations/states/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::create
* @see app/Http/Controllers/Admin/Locations/StateController.php:32
* @route '/admin/catalog/locations/states/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::create
* @see app/Http/Controllers/Admin/Locations/StateController.php:32
* @route '/admin/catalog/locations/states/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::create
* @see app/Http/Controllers/Admin/Locations/StateController.php:32
* @route '/admin/catalog/locations/states/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::create
* @see app/Http/Controllers/Admin/Locations/StateController.php:32
* @route '/admin/catalog/locations/states/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::create
* @see app/Http/Controllers/Admin/Locations/StateController.php:32
* @route '/admin/catalog/locations/states/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::store
* @see app/Http/Controllers/Admin/Locations/StateController.php:42
* @route '/admin/catalog/locations/states'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/catalog/locations/states',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::store
* @see app/Http/Controllers/Admin/Locations/StateController.php:42
* @route '/admin/catalog/locations/states'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::store
* @see app/Http/Controllers/Admin/Locations/StateController.php:42
* @route '/admin/catalog/locations/states'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::store
* @see app/Http/Controllers/Admin/Locations/StateController.php:42
* @route '/admin/catalog/locations/states'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::store
* @see app/Http/Controllers/Admin/Locations/StateController.php:42
* @route '/admin/catalog/locations/states'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::edit
* @see app/Http/Controllers/Admin/Locations/StateController.php:63
* @route '/admin/catalog/locations/states/{state}/edit'
*/
export const edit = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/catalog/locations/states/{state}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::edit
* @see app/Http/Controllers/Admin/Locations/StateController.php:63
* @route '/admin/catalog/locations/states/{state}/edit'
*/
edit.url = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { state: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { state: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            state: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        state: typeof args.state === 'object'
        ? args.state.id
        : args.state,
    }

    return edit.definition.url
            .replace('{state}', parsedArgs.state.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::edit
* @see app/Http/Controllers/Admin/Locations/StateController.php:63
* @route '/admin/catalog/locations/states/{state}/edit'
*/
edit.get = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::edit
* @see app/Http/Controllers/Admin/Locations/StateController.php:63
* @route '/admin/catalog/locations/states/{state}/edit'
*/
edit.head = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::edit
* @see app/Http/Controllers/Admin/Locations/StateController.php:63
* @route '/admin/catalog/locations/states/{state}/edit'
*/
const editForm = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::edit
* @see app/Http/Controllers/Admin/Locations/StateController.php:63
* @route '/admin/catalog/locations/states/{state}/edit'
*/
editForm.get = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::edit
* @see app/Http/Controllers/Admin/Locations/StateController.php:63
* @route '/admin/catalog/locations/states/{state}/edit'
*/
editForm.head = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::update
* @see app/Http/Controllers/Admin/Locations/StateController.php:74
* @route '/admin/catalog/locations/states/{state}'
*/
export const update = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/catalog/locations/states/{state}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::update
* @see app/Http/Controllers/Admin/Locations/StateController.php:74
* @route '/admin/catalog/locations/states/{state}'
*/
update.url = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { state: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { state: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            state: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        state: typeof args.state === 'object'
        ? args.state.id
        : args.state,
    }

    return update.definition.url
            .replace('{state}', parsedArgs.state.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::update
* @see app/Http/Controllers/Admin/Locations/StateController.php:74
* @route '/admin/catalog/locations/states/{state}'
*/
update.put = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::update
* @see app/Http/Controllers/Admin/Locations/StateController.php:74
* @route '/admin/catalog/locations/states/{state}'
*/
const updateForm = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::update
* @see app/Http/Controllers/Admin/Locations/StateController.php:74
* @route '/admin/catalog/locations/states/{state}'
*/
updateForm.put = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::destroy
* @see app/Http/Controllers/Admin/Locations/StateController.php:95
* @route '/admin/catalog/locations/states/{state}'
*/
export const destroy = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/catalog/locations/states/{state}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::destroy
* @see app/Http/Controllers/Admin/Locations/StateController.php:95
* @route '/admin/catalog/locations/states/{state}'
*/
destroy.url = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { state: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { state: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            state: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        state: typeof args.state === 'object'
        ? args.state.id
        : args.state,
    }

    return destroy.definition.url
            .replace('{state}', parsedArgs.state.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::destroy
* @see app/Http/Controllers/Admin/Locations/StateController.php:95
* @route '/admin/catalog/locations/states/{state}'
*/
destroy.delete = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::destroy
* @see app/Http/Controllers/Admin/Locations/StateController.php:95
* @route '/admin/catalog/locations/states/{state}'
*/
const destroyForm = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::destroy
* @see app/Http/Controllers/Admin/Locations/StateController.php:95
* @route '/admin/catalog/locations/states/{state}'
*/
destroyForm.delete = (args: { state: string | number | { id: string | number } } | [state: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::cities
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/admin/catalog/locations/states/{state}/cities'
*/
export const cities = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cities.url(args, options),
    method: 'get',
})

cities.definition = {
    methods: ["get","head"],
    url: '/admin/catalog/locations/states/{state}/cities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::cities
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/admin/catalog/locations/states/{state}/cities'
*/
cities.url = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { state: args }
    }

    if (Array.isArray(args)) {
        args = {
            state: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        state: args.state,
    }

    return cities.definition.url
            .replace('{state}', parsedArgs.state.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::cities
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/admin/catalog/locations/states/{state}/cities'
*/
cities.get = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cities.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::cities
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/admin/catalog/locations/states/{state}/cities'
*/
cities.head = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cities.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::cities
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/admin/catalog/locations/states/{state}/cities'
*/
const citiesForm = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cities.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::cities
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/admin/catalog/locations/states/{state}/cities'
*/
citiesForm.get = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cities.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::cities
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/admin/catalog/locations/states/{state}/cities'
*/
citiesForm.head = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cities.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cities.form = citiesForm

const states = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    cities: Object.assign(cities, cities5ebe3c),
}

export default states